import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { SingleRegistration } from './components/single-registration/single-registration';
import { Simple } from './components/forms/single/simple/simple';
import { WithAccomodation } from './components/forms/single/with-accomodation/with-accomodation';
import { Group } from './components/forms/group/group';
import { PaymentConfirmation } from './components/payment-confirmation/payment-confirmation';

export const routes: Routes = [
  {
    path: '',
    component: Home,
  },
  {
    path: 'single-registration',
    component: SingleRegistration,
  },
  {
    path: 'single-registration/simple',
    component: Simple,
  },
  {
    path: 'single-registration/with-accomodation',
    component: WithAccomodation,
  },
  {
    path: 'group-registration',
    component: Group,
  },
  {
    path: 'confirmation/:id',
    component: PaymentConfirmation,
  },
];
